import { createIcon } from '@chakra-ui/icons';

export const DragHandle = createIcon({
  displayName: 'DragHandle',
  viewBox: '0 0 16 17',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_454_5180)">
        <path
          d="M8 13.8337V11.167"
          stroke="#2D2D2D"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M2.66406 8.5H5.33073"
          stroke="#2D2D2D"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8 3.16699V5.83366"
          stroke="#2D2D2D"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M13.3307 8.5H10.6641"
          stroke="#2D2D2D"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.25293 0.613912C8.22087 0.57951 8.18207 0.552077 8.13894 0.53332C8.09582 0.514563 8.04929 0.504883 8.00227 0.504883C7.95524 0.504883 7.90871 0.514563 7.86559 0.53332C7.82247 0.552077 7.78366 0.57951 7.7516 0.613912L5.41826 3.28058C5.37616 3.32876 5.34881 3.38805 5.33949 3.45136C5.33017 3.51467 5.33927 3.57932 5.3657 3.6376C5.39213 3.69587 5.43478 3.74531 5.48855 3.78C5.54232 3.8147 5.60494 3.83318 5.66893 3.83325H10.3356C10.3996 3.83318 10.4622 3.8147 10.516 3.78C10.5697 3.74531 10.6124 3.69587 10.6388 3.6376C10.6653 3.57932 10.6744 3.51467 10.665 3.45136C10.6557 3.38805 10.6284 3.32876 10.5863 3.28058L8.25293 0.613912Z"
          fill="#2D2D2D"
        />
        <path
          d="M13.2167 5.91631C13.1685 5.87421 13.1093 5.84686 13.0459 5.83754C12.9826 5.82822 12.918 5.83732 12.8597 5.86375C12.8014 5.89018 12.752 5.93283 12.7173 5.9866C12.6826 6.04037 12.6641 6.10299 12.6641 6.16698V10.8336C12.6641 10.8976 12.6826 10.9603 12.7173 11.014C12.752 11.0678 12.8014 11.1104 12.8597 11.1369C12.918 11.1633 12.9826 11.1724 13.0459 11.1631C13.1093 11.1538 13.1685 11.1264 13.2167 11.0843L15.8834 8.75098C15.9191 8.71969 15.9477 8.68115 15.9673 8.63792C15.9869 8.59469 15.997 8.54777 15.997 8.50031C15.997 8.45285 15.9869 8.40594 15.9673 8.36271C15.9477 8.31948 15.9191 8.28093 15.8834 8.24965L13.2167 5.91631Z"
          fill="#2D2D2D"
        />
        <path
          d="M10.3356 13.166H5.66893C5.60494 13.1661 5.54232 13.1846 5.48855 13.2193C5.43478 13.2539 5.39213 13.3034 5.3657 13.3617C5.33927 13.4199 5.33017 13.4846 5.33949 13.5479C5.34881 13.6112 5.37616 13.6705 5.41826 13.7187L7.7516 16.3853C7.78288 16.421 7.82143 16.4496 7.86466 16.4692C7.90789 16.4888 7.9548 16.499 8.00227 16.499C8.04973 16.499 8.09664 16.4888 8.13987 16.4692C8.1831 16.4496 8.22165 16.421 8.25293 16.3853L10.5863 13.7187C10.6284 13.6705 10.6557 13.6112 10.665 13.5479C10.6744 13.4846 10.6653 13.4199 10.6388 13.3617C10.6124 13.3034 10.5697 13.2539 10.516 13.2193C10.4622 13.1846 10.3996 13.1661 10.3356 13.166Z"
          fill="#2D2D2D"
        />
        <path
          d="M3.13761 5.86283C3.07929 5.83635 3.01457 5.82723 2.95119 5.83657C2.88782 5.84591 2.82848 5.87331 2.78028 5.9155L0.113612 8.24883C0.0779209 8.28012 0.0493219 8.31866 0.0297288 8.36189C0.0101356 8.40512 0 8.45204 0 8.4995C0 8.54696 0.0101356 8.59387 0.0297288 8.6371C0.0493219 8.68033 0.0779209 8.71888 0.113612 8.75016L2.78028 11.0835C2.84097 11.1367 2.9189 11.1661 2.99961 11.1662C3.08802 11.1662 3.1728 11.131 3.23531 11.0685C3.29783 11.006 3.33295 10.9212 3.33295 10.8328V6.16616C3.33293 6.10219 3.3145 6.03957 3.27987 5.98579C3.24523 5.932 3.19585 5.88932 3.13761 5.86283Z"
          fill="#2D2D2D"
        />
      </g>
      <defs>
        <clipPath id="clip0_454_5180">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
